//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vueTelegramLogin from '@/components/login/vue-telegram-login.vue'
export default {
  components: {
    'vue-telegram-login': vueTelegramLogin
  },
  data () {
    return {
      clientId: '720725194691-5mlhk8dgsc12gg9409g8bthqhhras28p.apps.googleusercontent.com',
      googleBtnConfigs: {
        type: 'standard',
        shape: 'rectangular',
        theme: 'outline',
        text: 'continue_with',
        size: 'large',
        locale: 'es-419',
        logo_alignment: 'left',
        width: '279'
        // locale: "zh_CN"
      },
      LanguageCode: this.$store.state.LanguageCode, // 当前页面语言
      Loginorregistration: 1, // 1 为登录, 2 为注册
      login: { icon: 'https://resources1.interface003.com/web20/img/login/login.svg', name: this.$v('使用手机号或电子邮箱'), type: 1 },
      registration: { icon: 'https://resources1.interface003.com/web20/img/login/login.svg', name: this.$v('使用 电子邮件'), type: 1 },
      // logoData: [ // 登录方式
      //   // { icon: require('https://resources1.interface003.com/web20/img/login/weixin.svg'), url: null, name: this.$v('通过 微信 继续'), type: 2 },
      //   { icon: 'https://resources1.interface003.com/web20/img/login/facdbook.svg', url: null, name: this.$v('通过 Facebook 继续'), type: 3 },
      //   { icon: 'https://resources1.interface003.com/web20/img/login/Google.svg', name: this.$v('通过 Google 继续'), type: 4 }
      //   // { icon: require('https://resources1.interface003.com/web20/img/login/apple.svg'), name: this.$v('通过 Apple 继续'), type: 5 }
      // ],
      moreSte: false, // 更多状态
      Tripartite: [],
      goeLogin: false, // 谷歌登录
      isAdin: false
    }
  },
  computed: {
    logoData () {
      /* this.$store.state.myCountry != 'cn' */
      if (this.$store.state.myCountry != 'cn') {
        return [ // 登录方式
        // { icon: require('https://resources1.interface003.com/web20/img/login/weixin.svg'), url: null, name: this.$v('通过 微信 继续'), type: 2 },
          // { icon: 'https://resources1.interface003.com/web20/img/login/facdbook.svg', url: null, name: this.$v('通过 Facebook 继续'), type: 3 },
          { icon: 'https://resources1.interface003.com/web20/img/login/Google.svg', name: this.$v('通过 Google 继续'), type: 4 },
          { icon: 'https://resources1.interface003.com/web20/img/login/apple.svg', name: this.$v('通过 Apple 继续'), type: 5 },
          { icon: require('@/assets/img/class/telegram.svg'), name: this.$v('通过 Telegram 登录'), type: 7 }

        ]
      } else { // cn h5只有facebook apple
        return [ // 登录方式
        // { icon: require('https://resources1.interface003.com/web20/img/login/weixin.svg'), url: null, name: this.$v('通过 微信 继续'), type: 2 },
          // { icon: 'https://resources1.interface003.com/web20/img/login/facdbook.svg', url: null, name: this.$v('通过 Facebook 继续'), type: 3 },
          // { icon: 'https://resources1.interface003.com/web20/img/login/Google.svg', name: this.$v('通过 Google 继续'), type: 4 },
          { icon: 'https://resources1.interface003.com/web20/img/login/apple.svg', name: this.$v('通过 Apple 继续'), type: 5 }
          // { icon: require('@/assets/img/class/telegram.svg'), name: this.$v('通过 Telegram 登录'), type: 7 }
        ]
      }
    },
    voiceTitle () {
      if (this.loginCode == 2) {
        return this.$v('注册')
      } else {
        return this.$v('语言验证')
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getTripartite() // 获取三方地址
      console.log('页面宽度', window.innerWidth)
      if (window.innerWidth <= 500) this.isAdin = true
    })
    if (!this.$store.state.path.includes('login.html')) {
      this.$nextTick(() => {
        document.querySelector('.wiki-head').style.display = 'block'
      })
    }
  },
  methods: {
    yourCallbackFunction (user) {
      const that = this
      that.$api.usercenter.getWaistcoat({
        auth_date: user.auth_date,
        first_name: user.first_name,
        hash: user.hash,
        last_name: user.last_name,
        id: user.id,
        photo_url: user.photo_url ? user.photo_url : ''
      }, {
        HttpMethod: 'post',
        Route: 'usercenter$telegramcallback'
      }).then((res) => {
        that.googleLogin(res)
        console.log('telegram登录', res)
      }).catch((err) => {
        console.log(err)
      })
      console.log(user)
    },
    googlePop (type) {
      if (type == 4) {
        console.log('谷歌登录')
      }
    },
    setmore () { // 加载更多
      const more = [
        { icon: 'https://resources1.interface003.com/web20/img/login/Tuite.svg', name: this.$v('通过 Twitter 登录'), type: 6 },
        { icon: 'https://resources1.interface003.com/web20/img/login/live.svg', name: this.$v('通过 line 登录'), type: 7 }
      ]
      more.forEach(item => this.logoData.push(item))
      this.moreSte = false
    },
    async getTripartite () { // 获取三方地址
      const { succeed = false, extra = '', result = {} } = await this.$api.login.userThird()
      if (!succeed) return console.log(extra) // 数据错误
      this.Tripartite = result
      // this.logoData[0].url = result[1].LoginUrl
      this.$forceUpdate() // 强制渲染
      // this.logoData[1].url = result[1].LoginUrl
      if (this.$store.state.myCountry != 'cn') {
      // 谷歌
        const googleSignInAPI = document.createElement('script')
        googleSignInAPI.setAttribute(
          'src',
          'https://accounts.google.com/gsi/client'
        )
        document.head.appendChild(googleSignInAPI)
        const _that = this
        googleSignInAPI.onload = function () {
        // InitGoogleButton 初始化登录按钮
        // eslint-disable-next-line no-undef
          google.accounts.id.initialize({
            client_id: _that.clientId,
            callback: _that.OnSuccess,
            ux_mode: 'popup'
          })
          // eslint-disable-next-line no-undef
          // google.accounts.id.renderButton(
          //   document.getElementById('google-login-btn-m'),
          //   _that.googleBtnConfigs
          // )
          // googleBtnConfigs: {
          //   type: 'standard',
          //   shape: 'rectangular',
          //   theme: 'outline',
          //   text: 'continue_with',
          //   size: 'large',
          //   locale: 'es-419',
          //   logo_alignment: 'left',
          //   width: '279'
          //   // locale: "zh_CN"
          // },
          /*
        , {
          theme: 'outline',
          size: 'large',
          width: '279',
          locale: _that.$store.state.LanguageCode == 'zh' ? 'zh-hk' : _that.$store.state.LanguageCode,
          click_listener: onClickHandler
        }
        */
          // eslint-disable-next-line no-undef
          google.accounts.id.renderButton(document.getElementById('google-login-btn-m'), {
            type: 'standard',
            theme: 'outline',
            shape: 'rectangular',
            size: 'large',
            width: '279',
            locale: _that.$store.state.LanguageCode == 'zh' ? 'zh-hk' : _that.$store.state.LanguageCode
          })

        // function onClickHandler () {
        //   console.log('Sign in with Google button clicked...')
        // }
        }
      }
      // applyid
      const applyidSignInAPI = document.createElement('script')
      applyidSignInAPI.setAttribute(
        'src',
        'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
      )
      document.head.appendChild(applyidSignInAPI)
      const _that = this
      applyidSignInAPI.onload = function () {
        // eslint-disable-next-line no-undef
        AppleID.auth.init({
          clientId: 'com.wikifx.web',
          scope: 'name email',
          redirectURI: `https://liveroom${_that.$store.state.cookieHost}`,
          state: 'xcoiv98y2kd22vusuye3kch',
          // nonce : '[NONCE]',
          usePopup: true
        })
      }
      const buttonElement = document.querySelector('.appleid-signin-m')
      const that = this
      buttonElement.addEventListener('click', () => {
        // eslint-disable-next-line no-undef
        AppleID.auth.signIn().then(function (data) {
          console.log('1223', data)
          that.$api.usercenter.getWaistcoat({
            code: data.authorization.code
          }, {
            HttpMethod: 'get',
            Route: 'usercenter$webapplecallback'
          }).then((res) => {
            that.googleLogin(res)
            console.log('appleid登录', res)
          })
        }).catch((errr) => {
          console.log('apple', errr)
        })
      })
    },
    OnSuccess (resp) {
      console.log('resp: ', resp)
      this.onGoogleAuthSuccess(resp.credential)
    },
    onGoogleAuthSuccess (jwtCredentials) {
      console.log(jwtCredentials)
      this.$api.usercenter.getWaistcoat({
        Token: jwtCredentials
      }, {
        HttpMethod: 'post',
        Route: 'usercenter/web/googlecallback'
      }).then((res) => {
        console.log('res: ', res)
        // this.googleLogin(res)
        this.googleLogin(res)
      })
      // const profileData = JSON.parse(atob(jwtCredentials.split('.')[1]))
      // console.log('profileData: ', profileData)
      // const { name, picture, email } = profileData
      // console.table({ name, picture, email })
    },
    googleLogin (res) {
      if (res.isRegister) {
        this.$nextTick(() => {
          this.setCookie(res.cookieValue)
        })
      } else {
        setTimeout(() => {
          if (process.client) {
            const href = window.location.href.substr(0, window.location.href.indexOf('?')) ? window.location.href.substr(0, window.location.href.indexOf('?')) : window.location.href
            const ulr = `?type=register&id=${res.id}&name=${res.nickName}&img=${res.img}&logintype=${res.loginType}&email=${res.email ? res.email : null}&returnurl=${href}`
            // console.log('`https:', `https://${this.$store.state.host}/${this.$store.state.LanguageCode}/login.html${ulr}`)
            window.location.href = `//${this.$store.state.host}/${this.$store.state.LanguageCode}/login.html${ulr}`
          }
        }, 500)
      }
    },
    setCookie (cookievalue) {
      this.$store.commit('loginClose', false)
      if (cookievalue) {
        this.$api.home.clientgetUsercookie({ contentcookie: cookievalue }).then((res) => { // 主账号信息
          this.$store.commit('setUser', {
            userId: res.result.userId,
            nick: res.result.nick,
            avatar: res.result.avatar,
            vest: false // 是否为马甲号
          })
        })
      }
      if (this.$store.state.host.includes('wikifx')) {
        this.CookieSet(
          'DJkdikKMG',
          cookievalue,
          `.${this.$store.state.host.split('.')[1]}.${this.$store.state.suffix}`
        )
      } else if (this.$store.state.host.includes('fxeye')) {
        this.CookieSet(
          'ViLartidlakd',
          cookievalue,
          `.${this.$store.state.host.split('.')[1]}.${this.$store.state.suffix}`
        )
      } else {
        this.$cookies.set('WsdsfgDGdagYms', cookievalue)
        // this.CookieSet(
        //   'WsdsfgDGdagYms',
        //   result.Value,
        //   `.${this.comurl}.${this.$store.state.my_domin}`
        // )
        const postdata = {
          op_type: 'setCookie',
          url: '',
          parm: cookievalue
        }
        window.parent.postMessage(postdata, '*')
      }
      this.$store.commit('setUsercookie', cookievalue)
    },
    CookieSet (key, val, dom) { // 存cookie
      const expiresTime = new Date(Date.now() + 8.64e7 * 999)
      this.$cookies.set(key, val, {
        expires: expiresTime,
        path: '/',
        domain: dom
      })
    }
  }
}
